export default [
  {
    path: '/fulfillment/refer',
    name: 'FulfillmentRefer',
    component: () => import('@/views/fulfillment/refer'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/fulfillment/policy',
    name: 'FulfillmentPolicy',
    component: () => import('@/views/fulfillment/policy'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/fulfillment/endorsement',
    name: 'FulfillmentEndorsement',
    component: () => import('@/views/fulfillment/endorsement'),
    meta: {
      keepAlive: false
    }
  },
]